var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('span'),_c('span',[_vm._v("您当前没有权限访问该页面！o(╥﹏╥)o")]),_c('br'),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$router.push({name:'screen'})}}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }